import gql from "graphql-tag";

export const GET_USER_NAME = gql`
  query getUserName {
    getUserName
  }
`;
